import { AppThunk } from '@/store'
import { request } from '@/store/actions'

import { FETCH_GROUPS } from './actionTypes'

export const fetchGroups = (): AppThunk => {
  return dispatch => {
    return dispatch(request('/organizations/:organizationId/groups', FETCH_GROUPS, {}))
  }
}
